import type {
    FirestoreDataConverter,
    QueryDocumentSnapshot,
    SnapshotOptions,
} from 'firebase/firestore'
import type { SimulatorChallenge, SimulatorChallengeDocument } from '~/types/simulator/simulator'

export const simulatorChallengeConverter: FirestoreDataConverter<SimulatorChallenge> = {
    fromFirestore: (
        snapshot: QueryDocumentSnapshot<SimulatorChallenge>,
        options: SnapshotOptions,
    ): SimulatorChallenge => {
        const data = snapshot.data(options)

        return { ...data, id: snapshot.id } as SimulatorChallenge // Adjust this mapping as necessary
    },
    toFirestore: (modelObject: SimulatorChallenge): SimulatorChallengeDocument => {
        const { id, ...simulatorChallengeDoc } = modelObject
        return { ...simulatorChallengeDoc }
    },
}
